module.exports = __webpack_public_path__ + "img/SINGLE DEVICE SX BW.81608f3.svg";